// extracted by mini-css-extract-plugin
module.exports = {"popupRow":"List_popupRow_3UYKc","pagination":"List_pagination_ZmQ5i","paginationText":"List_paginationText_2oEYJ","paginationButton":"List_paginationButton_2LGlr"};